import { gql } from "@apollo/client";

export const SEARCH_AI_RESULTS_BY_KEYWORD = gql`
  query SearchAiResultsByKeyword($input: SearchAiSearchResultsInput!) {
    searchAiResultsByKeyword(input: $input) {
      items {
        id
        standardized_name
        lowest_price
        representative_image_url
        lotte_discount_price_usd
        hd_discount_price_usd
        shilla_discount_price_usd
        ssg_discount_price_usd
        created_at
      }
    }
  }
`;

// AI 검색 결과를 가져오는 쿼리
export const GET_AI_SEARCH_RESULTS = gql`
  query listAiProductsV2($page: Int, $limit: Int) {
    listAiProductsV2(page: $page, limit: $limit) {
      items {
        id
        standardized_name
        standardized_brand
        category
        representative_image_url
        lowest_price
        lotte_discount_price_usd
        hd_discount_price_usd
        shilla_discount_price_usd
        ssg_discount_price_usd
        created_at
      }
    }
  }
`;

// 새로운 쿼리 요청 생성 뮤테이션
export const CREATE_QUERY_REQUEST = gql`
  mutation CreateQueryRequest(
    $createQueryRequestInput: CreateQueryRequestInput!
  ) {
    createQueryRequest(createQueryRequestInput: $createQueryRequestInput) {
      id
      query_text
      email
      status
    }
  }
`;

/* 이전 SUBMIT_MISSING_ITEM_REQUEST 주석 처리 또는 삭제
export const SUBMIT_MISSING_ITEM_REQUEST = gql`
  mutation SubmitMissingItemRequest($keyword: String!) {
    submitMissingItemRequest(keyword: $keyword) {
      success
      message
    }
  }
`;
*/
